module.exports = __webpack_public_path__ + "img/Slice 268@2x(7).4af7e287.png";